import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { $serializer_getInstance1wkzh194ew9wf as $serializer_getInstance } from './proofModels.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Default_getInstance3483fw4bkmewo as Default_getInstance,
  PaddingOption_ABSENT_OPTIONAL_getInstanceopa392vnv2j4 as PaddingOption_ABSENT_OPTIONAL_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function WebAuthN$GeneralPreference$Companion$_anonymous__2q2k8y() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.GeneralPreference', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  GeneralPreference_Discouraged_instance = new (GeneralPreference())('Discouraged', 0, 'discouraged');
  GeneralPreference_Preferred_instance = new (GeneralPreference())('Preferred', 1, 'preferred');
  GeneralPreference_Required_instance = new (GeneralPreference())('Required', 2, 'required');
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var GeneralPreference_Discouraged_instance;
var GeneralPreference_Preferred_instance;
var GeneralPreference_Required_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, WebAuthN$GeneralPreference$Companion$_anonymous__2q2k8y);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
function values() {
  static_init();
  return [GeneralPreference_Discouraged_getInstance(), GeneralPreference_Preferred_getInstance(), GeneralPreference_Required_getInstance()];
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function WebAuthN$Transport$Companion$_anonymous__3e6jew() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Transport', values_0());
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  Transport_BLE_instance = new (Transport())('BLE', 0, 'ble');
  Transport_Hybrid_instance = new (Transport())('Hybrid', 1, 'hybrid');
  Transport_Internal_instance = new (Transport())('Internal', 2, 'internal');
  Transport_NFC_instance = new (Transport())('NFC', 3, 'nfc');
  Transport_USB_instance = new (Transport())('USB', 4, 'usb');
  if (Companion_instance_1 === VOID) {
    Companion_instance;
    new (Companion_0())();
  }
}
var Transport_BLE_instance;
var Transport_Hybrid_instance;
var Transport_Internal_instance;
var Transport_NFC_instance;
var Transport_USB_instance;
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, WebAuthN$Transport$Companion$_anonymous__3e6jew);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  static_init_0();
  return Companion_instance_1;
}
function values_0() {
  static_init_0();
  return [Transport_BLE_getInstance(), Transport_Hybrid_getInstance(), Transport_Internal_getInstance(), Transport_NFC_getInstance(), Transport_USB_getInstance()];
}
function WebAuthN$ExistingCredential$Companion$$childSerializers$_anonymous__qau40m() {
  return new (ArrayListSerializer())(Companion_getInstance_0().serializer_9w0wvi_k$());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, WebAuthN$ExistingCredential$Companion$$childSerializers$_anonymous__qau40m), null];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.ExistingCredential', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transports', true);
        tmp0_serialDesc.addElement_5pzumi_k$('type', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_fqbco5_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.id_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !equals(value.transports_1, emptyList())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.transports_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.type_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fqbco5_k$(encoder, value instanceof ExistingCredential() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ExistingCredential().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_ExistingCredential_g7p689_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function WebAuthN$Hints$Companion$_anonymous__6o1mfp() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Hints', values_1());
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  Hints_SecurityKey_instance = new (Hints())('SecurityKey', 0, 'security-key');
  Hints_ClientDevice_instance = new (Hints())('ClientDevice', 1, 'client-device');
  Hints_Hybrid_instance = new (Hints())('Hybrid', 2, 'hybrid');
  if (Companion_instance_3 === VOID) {
    Companion_instance;
    new (Companion_2())();
  }
}
var Hints_SecurityKey_instance;
var Hints_ClientDevice_instance;
var Hints_Hybrid_instance;
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, WebAuthN$Hints$Companion$_anonymous__6o1mfp);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  static_init_1();
  return Companion_instance_3;
}
function values_1() {
  static_init_1();
  return [Hints_SecurityKey_getInstance(), Hints_ClientDevice_getInstance(), Hints_Hybrid_getInstance()];
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  return Companion_instance_4;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.LargeBlob', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('read', false);
        tmp0_serialDesc.addElement_5pzumi_k$('write', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_enxrb9_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), value.read_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.write_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_enxrb9_k$(encoder, value instanceof LargeBlob() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LargeBlob().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_LargeBlob_oiwsub_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  return Companion_instance_5;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.LargeBlobResponse', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('written', false);
        tmp0_serialDesc.addElement_5pzumi_k$('blob', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8cmc8q_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 0, value.written_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.blob_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8cmc8q_k$(encoder, value instanceof LargeBlobResponse() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = false;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LargeBlobResponse().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_LargeBlobResponse_kppk8l_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_5() {
  return Companion_instance_6;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.RequestExtensions', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('appid', true);
        tmp0_serialDesc.addElement_5pzumi_k$('largeBlob', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8cho8g_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.appid_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, StringSerializer_getInstance(), value.appid_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.largeBlob_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance_1(), value.largeBlob_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8cho8g_k$(encoder, value instanceof RequestExtensions() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RequestExtensions().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_RequestExtensions_rqkewd_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_1())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_6() {
  return Companion_instance_7;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.RequestExtensionsResponse', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('appid', true);
        tmp0_serialDesc.addElement_5pzumi_k$('largeBlob', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_pa2xov_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.appid_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), value.appid_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.largeBlob_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance_2(), value.largeBlob_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pa2xov_k$(encoder, value instanceof RequestExtensionsResponse() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RequestExtensionsResponse().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_RequestExtensionsResponse_ierp3u_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_2())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw_0() {
  return new (ArrayListSerializer())(Companion_getInstance_2().serializer_9w0wvi_k$());
}
function WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw_1() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, null, null, tmp_3, null, null, lazy(tmp_4, WebAuthN$Authentication$PublicKeyCredentialRequestOptions$Companion$$childSerializers$_anonymous__88lkmw_1)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_7() {
  if (Companion_instance_8 === VOID)
    new (Companion_7())();
  return Companion_instance_8;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.PublicKeyCredentialRequestOptions', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('allowCredentials', true);
        tmp0_serialDesc.addElement_5pzumi_k$('challenge', false);
        tmp0_serialDesc.addElement_5pzumi_k$('extensions', true);
        tmp0_serialDesc.addElement_5pzumi_k$('hints', true);
        tmp0_serialDesc.addElement_5pzumi_k$('rpId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('timeout', true);
        tmp0_serialDesc.addElement_5pzumi_k$('userVerification', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_108qmv_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().$childSerializers_1;
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.allowCredentials_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.allowCredentials_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.challenge_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !value.extensions_1.equals(new (RequestExtensions())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_3(), value.extensions_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !equals(value.hints_1, emptyList())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.hints_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.rpId_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.timeout_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, IntSerializer_getInstance(), value.timeout_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !value.userVerification_1.equals(GeneralPreference_Preferred_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.userVerification_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_108qmv_k$(encoder, value instanceof PublicKeyCredentialRequestOptions() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_7().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return PublicKeyCredentialRequestOptions().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_PublicKeyCredentialRequestOptions_o0xooa_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_7().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].get_value_j01efc_k$(), StringSerializer_getInstance(), $serializer_getInstance_3(), tmp0_cached[3].get_value_j01efc_k$(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), tmp0_cached[6].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_5() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_8() {
  return Companion_instance_9;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.AssertedPublicKeyCredential', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('clientExtensionResults', false);
        tmp0_serialDesc.addElement_5pzumi_k$('response', false);
        tmp0_serialDesc.addElement_5pzumi_k$('type', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_exwbcb_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.id_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance_4(), value.clientExtensionResults_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_7(), value.response_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.type_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_exwbcb_k$(encoder, value instanceof AssertedPublicKeyCredential() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AssertedPublicKeyCredential().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_AssertedPublicKeyCredential_96yov8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_4()), $serializer_getInstance_7(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_6() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_9() {
  return Companion_instance_10;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.AuthenticatorAssertionResponse', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('authenticatorData', false);
        tmp0_serialDesc.addElement_5pzumi_k$('clientDataJSON', false);
        tmp0_serialDesc.addElement_5pzumi_k$('signature', false);
        tmp0_serialDesc.addElement_5pzumi_k$('userHandle', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_kyymv7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.authenticatorData_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.clientDataJSON_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.signature_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, StringSerializer_getInstance(), value.userHandle_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kyymv7_k$(encoder, value instanceof AuthenticatorAssertionResponse() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AuthenticatorAssertionResponse().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_AuthenticatorAssertionResponse_g7uec0_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_7() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_10() {
  return Companion_instance_11;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.StartRequest', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('proof', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_oao4my_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.type_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.proof_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance(), value.proof_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_oao4my_k$(encoder, value instanceof StartRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return StartRequest().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_StartRequest_hgdkkp_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable($serializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_8() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_11() {
  return Companion_instance_12;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.StartResponse', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('challengeId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_f1k14g_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.challengeId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_5(), value.options_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_f1k14g_k$(encoder, value instanceof StartResponse() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return StartResponse().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_StartResponse_50hoep_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_9() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_12() {
  return Companion_instance_13;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.WebAuthN.Authentication.ProveRequest', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('challengeId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('credentials', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_sx97ls_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.challengeId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_6(), value.credentials_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_sx97ls_k$(encoder, value instanceof ProveRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProveRequest().new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_ProveRequest_ushiav_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_6()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_10() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var LargeBlobClass;
function LargeBlob() {
  if (LargeBlobClass === VOID) {
    class $ {
      constructor(read, write) {
        this.read_1 = read;
        this.write_1 = write;
      }
      toString() {
        return 'LargeBlob(read=' + this.read_1 + ', write=' + this.write_1 + ')';
      }
      hashCode() {
        var result = this.read_1 == null ? 0 : getBooleanHashCode(this.read_1);
        result = imul(result, 31) + (this.write_1 == null ? 0 : getStringHashCode(this.write_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LargeBlob()))
          return false;
        if (!(this.read_1 == other.read_1))
          return false;
        if (!(this.write_1 == other.write_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_LargeBlob_oiwsub_k$(seen0, read, write, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.read_1 = read;
        $this.write_1 = write;
        return $this;
      }
    }
    initMetadataForClass($, 'LargeBlob', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    LargeBlobClass = $;
  }
  return LargeBlobClass;
}
var LargeBlobResponseClass;
function LargeBlobResponse() {
  if (LargeBlobResponseClass === VOID) {
    class $ {
      constructor(written, blob) {
        this.written_1 = written;
        this.blob_1 = blob;
      }
      toString() {
        return 'LargeBlobResponse(written=' + this.written_1 + ', blob=' + this.blob_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.written_1);
        result = imul(result, 31) + (this.blob_1 == null ? 0 : getStringHashCode(this.blob_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LargeBlobResponse()))
          return false;
        if (!(this.written_1 === other.written_1))
          return false;
        if (!(this.blob_1 == other.blob_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_LargeBlobResponse_kppk8l_k$(seen0, written, blob, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.written_1 = written;
        $this.blob_1 = blob;
        return $this;
      }
    }
    initMetadataForClass($, 'LargeBlobResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    LargeBlobResponseClass = $;
  }
  return LargeBlobResponseClass;
}
var RequestExtensionsClass;
function RequestExtensions() {
  if (RequestExtensionsClass === VOID) {
    class $ {
      constructor(appid, largeBlob) {
        appid = appid === VOID ? null : appid;
        largeBlob = largeBlob === VOID ? null : largeBlob;
        this.appid_1 = appid;
        this.largeBlob_1 = largeBlob;
      }
      toString() {
        return 'RequestExtensions(appid=' + this.appid_1 + ', largeBlob=' + toString_0(this.largeBlob_1) + ')';
      }
      hashCode() {
        var result = this.appid_1 == null ? 0 : getStringHashCode(this.appid_1);
        result = imul(result, 31) + (this.largeBlob_1 == null ? 0 : this.largeBlob_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestExtensions()))
          return false;
        if (!(this.appid_1 == other.appid_1))
          return false;
        if (!equals(this.largeBlob_1, other.largeBlob_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_RequestExtensions_rqkewd_k$(seen0, appid, largeBlob, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.appid_1 = null;
        else
          $this.appid_1 = appid;
        if (0 === (seen0 & 2))
          $this.largeBlob_1 = null;
        else
          $this.largeBlob_1 = largeBlob;
        return $this;
      }
    }
    initMetadataForClass($, 'RequestExtensions', RequestExtensions, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    RequestExtensionsClass = $;
  }
  return RequestExtensionsClass;
}
var RequestExtensionsResponseClass;
function RequestExtensionsResponse() {
  if (RequestExtensionsResponseClass === VOID) {
    class $ {
      constructor(appid, largeBlob) {
        appid = appid === VOID ? null : appid;
        largeBlob = largeBlob === VOID ? null : largeBlob;
        this.appid_1 = appid;
        this.largeBlob_1 = largeBlob;
      }
      toString() {
        return 'RequestExtensionsResponse(appid=' + this.appid_1 + ', largeBlob=' + toString_0(this.largeBlob_1) + ')';
      }
      hashCode() {
        var result = this.appid_1 == null ? 0 : getBooleanHashCode(this.appid_1);
        result = imul(result, 31) + (this.largeBlob_1 == null ? 0 : this.largeBlob_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestExtensionsResponse()))
          return false;
        if (!(this.appid_1 == other.appid_1))
          return false;
        if (!equals(this.largeBlob_1, other.largeBlob_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_RequestExtensionsResponse_ierp3u_k$(seen0, appid, largeBlob, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.appid_1 = null;
        else
          $this.appid_1 = appid;
        if (0 === (seen0 & 2))
          $this.largeBlob_1 = null;
        else
          $this.largeBlob_1 = largeBlob;
        return $this;
      }
    }
    initMetadataForClass($, 'RequestExtensionsResponse', RequestExtensionsResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    RequestExtensionsResponseClass = $;
  }
  return RequestExtensionsResponseClass;
}
var PublicKeyCredentialRequestOptionsClass;
function PublicKeyCredentialRequestOptions() {
  if (PublicKeyCredentialRequestOptionsClass === VOID) {
    class $ {
      constructor(allowCredentials, challenge, extensions, hints, rpId, timeout, userVerification) {
        Companion_getInstance_7();
        var tmp;
        if (allowCredentials === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = allowCredentials;
        }
        allowCredentials = tmp;
        extensions = extensions === VOID ? new (RequestExtensions())() : extensions;
        hints = hints === VOID ? emptyList() : hints;
        timeout = timeout === VOID ? null : timeout;
        userVerification = userVerification === VOID ? GeneralPreference_Preferred_getInstance() : userVerification;
        this.allowCredentials_1 = allowCredentials;
        this.challenge_1 = challenge;
        this.extensions_1 = extensions;
        this.hints_1 = hints;
        this.rpId_1 = rpId;
        this.timeout_1 = timeout;
        this.userVerification_1 = userVerification;
      }
      toString() {
        return 'PublicKeyCredentialRequestOptions(allowCredentials=' + toString(this.allowCredentials_1) + ', challenge=' + this.challenge_1 + ', extensions=' + this.extensions_1.toString() + ', hints=' + toString(this.hints_1) + ', rpId=' + this.rpId_1 + ', timeout=' + this.timeout_1 + ', userVerification=' + this.userVerification_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.allowCredentials_1);
        result = imul(result, 31) + getStringHashCode(this.challenge_1) | 0;
        result = imul(result, 31) + this.extensions_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.hints_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.rpId_1) | 0;
        result = imul(result, 31) + (this.timeout_1 == null ? 0 : this.timeout_1) | 0;
        result = imul(result, 31) + this.userVerification_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PublicKeyCredentialRequestOptions()))
          return false;
        if (!equals(this.allowCredentials_1, other.allowCredentials_1))
          return false;
        if (!(this.challenge_1 === other.challenge_1))
          return false;
        if (!this.extensions_1.equals(other.extensions_1))
          return false;
        if (!equals(this.hints_1, other.hints_1))
          return false;
        if (!(this.rpId_1 === other.rpId_1))
          return false;
        if (!(this.timeout_1 == other.timeout_1))
          return false;
        if (!this.userVerification_1.equals(other.userVerification_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_PublicKeyCredentialRequestOptions_o0xooa_k$(seen0, allowCredentials, challenge, extensions, hints, rpId, timeout, userVerification, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(18 === (18 & seen0))) {
          throwMissingFieldException(seen0, 18, $serializer_getInstance_5().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.allowCredentials_1 = emptyList();
        } else
          $this.allowCredentials_1 = allowCredentials;
        $this.challenge_1 = challenge;
        if (0 === (seen0 & 4))
          $this.extensions_1 = new (RequestExtensions())();
        else
          $this.extensions_1 = extensions;
        if (0 === (seen0 & 8))
          $this.hints_1 = emptyList();
        else
          $this.hints_1 = hints;
        $this.rpId_1 = rpId;
        if (0 === (seen0 & 32))
          $this.timeout_1 = null;
        else
          $this.timeout_1 = timeout;
        if (0 === (seen0 & 64))
          $this.userVerification_1 = GeneralPreference_Preferred_getInstance();
        else
          $this.userVerification_1 = userVerification;
        return $this;
      }
    }
    initMetadataForClass($, 'PublicKeyCredentialRequestOptions', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    PublicKeyCredentialRequestOptionsClass = $;
  }
  return PublicKeyCredentialRequestOptionsClass;
}
var AssertedPublicKeyCredentialClass;
function AssertedPublicKeyCredential() {
  if (AssertedPublicKeyCredentialClass === VOID) {
    class $ {
      constructor(id, clientExtensionResults, response) {
        this.id_1 = id;
        this.clientExtensionResults_1 = clientExtensionResults;
        this.response_1 = response;
        this.type_1 = 'public-key';
      }
      toString() {
        return 'AssertedPublicKeyCredential(id=' + this.id_1 + ', clientExtensionResults=' + toString_0(this.clientExtensionResults_1) + ', response=' + this.response_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.id_1);
        result = imul(result, 31) + (this.clientExtensionResults_1 == null ? 0 : this.clientExtensionResults_1.hashCode()) | 0;
        result = imul(result, 31) + this.response_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AssertedPublicKeyCredential()))
          return false;
        if (!(this.id_1 === other.id_1))
          return false;
        if (!equals(this.clientExtensionResults_1, other.clientExtensionResults_1))
          return false;
        if (!this.response_1.equals(other.response_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_AssertedPublicKeyCredential_96yov8_k$(seen0, id, clientExtensionResults, response, type, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        $this.clientExtensionResults_1 = clientExtensionResults;
        $this.response_1 = response;
        if (0 === (seen0 & 8))
          $this.type_1 = 'public-key';
        else
          $this.type_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'AssertedPublicKeyCredential', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
    AssertedPublicKeyCredentialClass = $;
  }
  return AssertedPublicKeyCredentialClass;
}
var AuthenticatorAssertionResponseClass;
function AuthenticatorAssertionResponse() {
  if (AuthenticatorAssertionResponseClass === VOID) {
    class $ {
      constructor(authenticatorData, clientDataJSON, signature, userHandle) {
        this.authenticatorData_1 = authenticatorData;
        this.clientDataJSON_1 = clientDataJSON;
        this.signature_1 = signature;
        this.userHandle_1 = userHandle;
      }
      toString() {
        return 'AuthenticatorAssertionResponse(authenticatorData=' + this.authenticatorData_1 + ', clientDataJSON=' + this.clientDataJSON_1 + ', signature=' + this.signature_1 + ', userHandle=' + this.userHandle_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.authenticatorData_1);
        result = imul(result, 31) + getStringHashCode(this.clientDataJSON_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.signature_1) | 0;
        result = imul(result, 31) + (this.userHandle_1 == null ? 0 : getStringHashCode(this.userHandle_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthenticatorAssertionResponse()))
          return false;
        if (!(this.authenticatorData_1 === other.authenticatorData_1))
          return false;
        if (!(this.clientDataJSON_1 === other.clientDataJSON_1))
          return false;
        if (!(this.signature_1 === other.signature_1))
          return false;
        if (!(this.userHandle_1 == other.userHandle_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_AuthenticatorAssertionResponse_g7uec0_k$(seen0, authenticatorData, clientDataJSON, signature, userHandle, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_7().descriptor_1);
        }
        var $this = createThis(this);
        $this.authenticatorData_1 = authenticatorData;
        $this.clientDataJSON_1 = clientDataJSON;
        $this.signature_1 = signature;
        $this.userHandle_1 = userHandle;
        return $this;
      }
    }
    initMetadataForClass($, 'AuthenticatorAssertionResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    AuthenticatorAssertionResponseClass = $;
  }
  return AuthenticatorAssertionResponseClass;
}
var StartRequestClass;
function StartRequest() {
  if (StartRequestClass === VOID) {
    class $ {
      constructor(type, proof) {
        proof = proof === VOID ? null : proof;
        this.type_1 = type;
        this.proof_1 = proof;
      }
      toString() {
        return 'StartRequest(type=' + this.type_1 + ', proof=' + toString_0(this.proof_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.type_1);
        result = imul(result, 31) + (this.proof_1 == null ? 0 : this.proof_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StartRequest()))
          return false;
        if (!(this.type_1 === other.type_1))
          return false;
        if (!equals(this.proof_1, other.proof_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_StartRequest_hgdkkp_k$(seen0, type, proof, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        $this.type_1 = type;
        if (0 === (seen0 & 2))
          $this.proof_1 = null;
        else
          $this.proof_1 = proof;
        return $this;
      }
    }
    initMetadataForClass($, 'StartRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    StartRequestClass = $;
  }
  return StartRequestClass;
}
var StartResponseClass;
function StartResponse() {
  if (StartResponseClass === VOID) {
    class $ {
      constructor(challengeId, options) {
        this.challengeId_1 = challengeId;
        this.options_1 = options;
      }
      component1_7eebsc_k$() {
        return this.challengeId_1;
      }
      component2_7eebsb_k$() {
        return this.options_1;
      }
      toString() {
        return 'StartResponse(challengeId=' + this.challengeId_1 + ', options=' + this.options_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.challengeId_1);
        result = imul(result, 31) + this.options_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StartResponse()))
          return false;
        if (!(this.challengeId_1 === other.challengeId_1))
          return false;
        if (!this.options_1.equals(other.options_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_StartResponse_50hoep_k$(seen0, challengeId, options, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_9().descriptor_1);
        }
        var $this = createThis(this);
        $this.challengeId_1 = challengeId;
        $this.options_1 = options;
        return $this;
      }
    }
    initMetadataForClass($, 'StartResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    StartResponseClass = $;
  }
  return StartResponseClass;
}
var ProveRequestClass;
function ProveRequest() {
  if (ProveRequestClass === VOID) {
    class $ {
      constructor(challengeId, credentials) {
        this.challengeId_1 = challengeId;
        this.credentials_1 = credentials;
      }
      toString() {
        return 'ProveRequest(challengeId=' + this.challengeId_1 + ', credentials=' + this.credentials_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.challengeId_1);
        result = imul(result, 31) + this.credentials_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProveRequest()))
          return false;
        if (!(this.challengeId_1 === other.challengeId_1))
          return false;
        if (!this.credentials_1.equals(other.credentials_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_Authentication_ProveRequest_ushiav_k$(seen0, challengeId, credentials, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_10().descriptor_1);
        }
        var $this = createThis(this);
        $this.challengeId_1 = challengeId;
        $this.credentials_1 = credentials;
        return $this;
      }
    }
    initMetadataForClass($, 'ProveRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
    ProveRequestClass = $;
  }
  return ProveRequestClass;
}
var GeneralPreferenceClass;
function GeneralPreference() {
  if (GeneralPreferenceClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, standardName) {
        super(name, ordinal);
        this.standardName_1 = standardName;
      }
    }
    initMetadataForClass($, 'GeneralPreference', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    GeneralPreferenceClass = $;
  }
  return GeneralPreferenceClass;
}
var TransportClass;
function Transport() {
  if (TransportClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, standardName) {
        super(name, ordinal);
        this.standardName_1 = standardName;
      }
    }
    initMetadataForClass($, 'Transport', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    TransportClass = $;
  }
  return TransportClass;
}
var ExistingCredentialClass;
function ExistingCredential() {
  if (ExistingCredentialClass === VOID) {
    class $ {
      constructor(id, transports) {
        Companion_getInstance_1();
        transports = transports === VOID ? emptyList() : transports;
        this.id_1 = id;
        this.transports_1 = transports;
        this.type_1 = 'public-key';
      }
      toString() {
        return 'ExistingCredential(id=' + this.id_1 + ', transports=' + toString(this.transports_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.id_1);
        result = imul(result, 31) + hashCode(this.transports_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExistingCredential()))
          return false;
        if (!(this.id_1 === other.id_1))
          return false;
        if (!equals(this.transports_1, other.transports_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_WebAuthN_ExistingCredential_g7p689_k$(seen0, id, transports, type, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        if (0 === (seen0 & 2))
          $this.transports_1 = emptyList();
        else
          $this.transports_1 = transports;
        if (0 === (seen0 & 4))
          $this.type_1 = 'public-key';
        else
          $this.type_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'ExistingCredential', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    ExistingCredentialClass = $;
  }
  return ExistingCredentialClass;
}
var HintsClass;
function Hints() {
  if (HintsClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, standardName) {
        super(name, ordinal);
        this.standardName_1 = standardName;
      }
    }
    initMetadataForClass($, 'Hints', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    HintsClass = $;
  }
  return HintsClass;
}
function GeneralPreference_Discouraged_getInstance() {
  static_init();
  return GeneralPreference_Discouraged_instance;
}
function GeneralPreference_Preferred_getInstance() {
  static_init();
  return GeneralPreference_Preferred_instance;
}
function GeneralPreference_Required_getInstance() {
  static_init();
  return GeneralPreference_Required_instance;
}
function Transport_BLE_getInstance() {
  static_init_0();
  return Transport_BLE_instance;
}
function Transport_Hybrid_getInstance() {
  static_init_0();
  return Transport_Hybrid_instance;
}
function Transport_Internal_getInstance() {
  static_init_0();
  return Transport_Internal_instance;
}
function Transport_NFC_getInstance() {
  static_init_0();
  return Transport_NFC_instance;
}
function Transport_USB_getInstance() {
  static_init_0();
  return Transport_USB_instance;
}
function Hints_SecurityKey_getInstance() {
  static_init_1();
  return Hints_SecurityKey_instance;
}
function Hints_ClientDevice_getInstance() {
  static_init_1();
  return Hints_ClientDevice_instance;
}
function Hints_Hybrid_getInstance() {
  static_init_1();
  return Hints_Hybrid_instance;
}
var WebAuthNClass;
function WebAuthN() {
  if (WebAuthNClass === VOID) {
    class $ {
      constructor() {
        WebAuthN_instance = this;
        this.base64Encoder_1 = Default_getInstance().UrlSafe_1;
        this.base64Decoder_1 = Default_getInstance().UrlSafe_1.withPadding_845pcm_k$(PaddingOption_ABSENT_OPTIONAL_getInstance());
      }
    }
    initMetadataForObject($, 'WebAuthN');
    WebAuthNClass = $;
  }
  return WebAuthNClass;
}
var WebAuthN_instance;
function WebAuthN_getInstance() {
  if (WebAuthN_instance === VOID)
    new (WebAuthN())();
  return WebAuthN_instance;
}
//region block: init
Companion_instance_4 = new (Companion_3())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
Companion_instance_9 = new (Companion_8())();
Companion_instance_10 = new (Companion_9())();
Companion_instance_11 = new (Companion_10())();
Companion_instance_12 = new (Companion_11())();
Companion_instance_13 = new (Companion_12())();
//endregion
//region block: exports
export {
  AssertedPublicKeyCredential as AssertedPublicKeyCredentialkonu9s757pdm,
  AuthenticatorAssertionResponse as AuthenticatorAssertionResponse3v4lwwiyr1ss4,
  LargeBlobResponse as LargeBlobResponse3ghf03dywpz5w,
  ProveRequest as ProveRequestesb0i3d4v1f2,
  PublicKeyCredentialRequestOptions as PublicKeyCredentialRequestOptions1z3k9pcbf380y,
  RequestExtensionsResponse as RequestExtensionsResponse1fuq8aaa6zp1h,
  StartRequest as StartRequest3klm3ah1ehn7q,
  StartResponse as StartResponse1sgjxr7oj7f5v,
  WebAuthN_getInstance as WebAuthN_getInstance13tvuvmazia6l,
};
//endregion

//# sourceMappingURL=WebAuthN.mjs.map
